import "./QuestionCard.css";

const QuestionCard = ({
    index,
    data,
    selectedAnswers,
    onSelect,
    disabled,
}) => {
    return (
        <div className="question-card">
            <h3>
                Question {index}: {data.question_text}
                {data.allow_multiple_answers && (
                    <span style={{ fontWeight: 500 }}> (chọn tất cả đáp án đúng)</span>
                )}
            </h3>

            <div className="options-grid">
                {data.options.map((opt) => {
                    const selected = selectedAnswers.includes(opt.key);

                    return (
                        <div
                            key={opt.key}
                            className={`option-card ${selected ? "selected" : ""} ${disabled ? "disabled" : ""}`}
                            onClick={() =>
                                !disabled &&
                                onSelect(
                                    data.id,
                                    opt.key,
                                    data.allow_multiple_answers
                                )
                            }
                        >
                            <div className="option-indicator">
                                {selected ? "✓" : ""}
                            </div>
                            <span className="option-key">{opt.key}</span>
                            <span className="option-text">{opt.text}</span>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default QuestionCard;
